// @flow

import React from 'react';
import { useVDOMPortal } from '@ta/lithium.portals';
import Modal from '@ta/modal.styleguide';
import AttrPromoScreen from './10PercentOffPromoScreen';
import styles from './modal.css';

const useAttrPromoScreen = (): (() => mixed) => {
  const { open } = useVDOMPortal(({ close }) => (
    <Modal enableCloseIcon={false}>
      <div className={styles.container}>
        <AttrPromoScreen onContinue={close} />
      </div>
    </Modal>
  ));

  return open;
};

export default useAttrPromoScreen;
